import React from 'react';
import { TextField, RadioGroup, Radio, FormControlLabel } from '@mui/material';
import { Question } from '../../../types/questionnaire';
import { BaseQuestionRenderer } from './BaseQuestionRenderer';

interface InputRendererProps {
  question: Question;
  value: any;
  onChange: (questionName: string, value: any) => void;
}

export const InputRenderer: React.FC<InputRendererProps> = ({ question, value, onChange }) => {
  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onChange(question.name, event.target.value);
  };

  // checkbox (булевий "так/ні") — 2 радіокнопки замість одинарного чекбоксу:
  // одинарний чекбокс не розрізняє "відповів Ні" від "ще не відповідав" (в обох випадках невідмічений),
  // тоді як тут "нічого не вибрано" — це явно відсутня відповідь, а не приховане "Ні".
  if (question.type === 'checkbox') {
    const radioValue = value === true || value === 'true' ? 'true' : value === false || value === 'false' ? 'false' : '';
    return (
      <BaseQuestionRenderer question={question}>
        <RadioGroup
          row
          value={radioValue}
          onChange={(event) => onChange(question.name, event.target.value)}
        >
          <FormControlLabel value="true" control={<Radio required={question.isRequired} />} label="Так" />
          <FormControlLabel value="false" control={<Radio required={question.isRequired} />} label="Ні" />
        </RadioGroup>
      </BaseQuestionRenderer>
    );
  }

  return (
    <BaseQuestionRenderer question={question}>
      <TextField
        fullWidth
        variant="outlined"
        type={question.type}
        value={value}
        placeholder={question.attributes.placeholder}
        required={question.isRequired}
        onChange={handleInputChange}
        inputProps={{
          min: question.attributes.min,
          step: question.attributes.step,
          inputMode: question.attributes.inputmode,
        }}
      />
    </BaseQuestionRenderer>
  );
};
